var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIconYellow02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 173,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.324 51.9c0-26.276 21.3-47.576 47.575-47.576h69.2c26.275 0 47.575 21.3 47.575 47.575v69.2c0 26.275-21.3 47.575-47.575 47.575h-69.2c-26.275 0-47.575-21.3-47.575-47.575v-69.2z",
    stroke: "#F9B035",
    strokeWidth: 8.65
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 44,
    width: 85,
    height: 85
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.706 44.33H38.367v84.339h84.339V44.33z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.35 89.126l14.932 5.79c3.085 1.194 6.529.775 9.267-1.135l31.817-22.177a1.761 1.761 0 012.297.238 1.965 1.965 0 01-.051 2.742L77.068 97.366c-1.343 1.297-1.237 3.551.22 4.705l24.868 19.737c4.482 3.559 10.972.817 11.832-4.999l8.656-58.43c.612-4.118-3.338-7.336-7.01-5.714L42.263 85.12c-.764.336-1.26 1.119-1.26 1.985 0 .9.536 1.706 1.346 2.02z",
    fill: "#F9B035",
    stroke: "#F9B035",
    strokeWidth: 4.325
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIconYellow02);
export default __webpack_public_path__ + "static/media/telegram-icon-yellow02.a3764e2bc9958ec6d204a5597ec5143c.svg";
export { ForwardRef as ReactComponent };